import { useCallback, useState } from "react";
import { getAuthCode } from "../services/app";

/**
 * useSsoShopifyUrl
 * @param {Object} params
 * @param {string} params.storeShopifyUrl - User's Shopify store URL (with or without scheme)
 * @param {Object} [params.query] - Additional query params as key-value pairs
 * @returns {Function} Callback with redirect URL
 */
export default function useSsoShopifyUrl({ storeShopifyUrl, checkoutUrl }) {
  const [isLoading, setIsLoading] = useState(false);

  const buildUrl = useCallback((token) => {
    if (!storeShopifyUrl) {
      return "";
    }
    let urlWithoutScheme = "";
    try {
      const urlObj = new URL(
        storeShopifyUrl.startsWith("http")
          ? storeShopifyUrl
          : `https://${storeShopifyUrl}`
      );
      urlWithoutScheme = urlObj.host + urlObj.pathname.replace(/\/$/, "");
    } catch {
      urlWithoutScheme = storeShopifyUrl
        .replace(/^https?:\/\//, "")
        .replace(/\/$/, "");
    }

    let baseUrl = process.env.REACT_APP_SHOPIFY_CUSTOMAPP_URL || "";
    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
    if (urlWithoutScheme.startsWith("/"))
      urlWithoutScheme = urlWithoutScheme.slice(1);

    return `${baseUrl}/${urlWithoutScheme}/sso/login?code=${token}&checkoutUrl=${checkoutUrl ?? '/'}`;
  }, [storeShopifyUrl, checkoutUrl]);

  const getShortLivedToken = async () => {
    const res = await getAuthCode();
    if (res.data) {
      return res.data.data.code;
    }
  }

  const shopifyUrl = useCallback(
    async (callback, onError) => {
      try {
        setIsLoading(true);
        const token = await getShortLivedToken();
        if (typeof callback === "function") {
          callback(buildUrl(token));
        }
      } catch (error) {
        console.error("Error fetching Shopify URL:", error);
        if (typeof onError === "function") {
          onError(error);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [buildUrl]
  );

  return {shopifyUrl, isLoading} ;
}
